import SelectAllStudies from './SelectAllStudies';

export default SelectAllStudies;
